import { CarouselBaseCard } from '@post-office/browser--growth-starburst/common/carouselBaseCard';

import {
	type CardImages,
	type CarouselCardProps,
} from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { commonTwcMessages } from '@post-office/browser--growth-starburst/common/constants';

import { defineMessages } from 'react-intl';

import { ChatCardIllustrationDark } from '../assets/ChatCardIllustrationDark';

import { ChatCardIllustrationLight } from '../assets/ChatCardIllustrationLight';

import { type JSX } from 'react/jsx-runtime';

export const ChatOnboardingCard = (props: CarouselCardProps): JSX.Element => {
	const images: CardImages = {
		component: <ChatCardIllustrationLight />,
		componentDark: <ChatCardIllustrationDark />,
	};
	return (
		<CarouselBaseCard
			messages={{ ...chatMessages, ...commonTwcMessages }}
			images={images}
			{...props}
		/>
	);
};

const chatMessages = defineMessages({
	heading: {
		defaultMessage: 'Chat with Rovo',
		description: 'Heading for the Rovo chat onboarding card',
		id: 'townsquare.twc-onboarding-widget.chat-card.heading',
	},
	description: {
		defaultMessage: 'Get helpful answers to your questions and collaborate with AI on your work.',
		description: 'Description for the Rovo chat onboarding card',
		id: 'townsquare.twc-onboarding-widget.chat-card.description',
	},
	cta: {
		defaultMessage: 'Try Chat',
		description: 'Call to action text for the Rovo chat onboarding card',
		id: 'townsquare.twc-onboarding-widget.chat-card.cta',
	},
});
